/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Missing_Team_ErrorInputs */

const en_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to sync Team Project. Your user does not belong to a team.`)
};

const fr_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de synchroniser le projet d’équipe. Votre utilisateur n’appartient à aucune équipe.`)
};

const de_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamprojekt konnte nicht synchronisiert werden. Ihr Benutzer gehört keinem Team an.`)
};

const it_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile sincronizzare Team Project. L'utente non appartiene a nessun team.`)
};

const ru_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось синхронизировать проект команды. Ваш пользователь не принадлежит ни к одной команде.`)
};

const es_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede sincronizar el proyecto de equipo. Tu usuario no pertenece a ningún equipo.`)
};

const zh_cn2_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法同步团队项目。您的用户不属于任何团队。`)
};

const ja_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクトを同期できません。ユーザーはチームに属していません。`)
};

const hi_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट को सिंक करने में असमर्थ। आपका उपयोगकर्ता किसी टीम का सदस्य नहीं है।`)
};

const pt_pt2_team_sync_missing_team_error = /** @type {(inputs: Team_Sync_Missing_Team_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível sincronizar o Projeto de Equipe. Seu usuário não pertence a uma equipe.`)
};

/**
* | output |
* | --- |
* | "Unable to sync Team Project. Your user does not belong to a team." |
*
* @param {Team_Sync_Missing_Team_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_missing_team_error = /** @type {((inputs?: Team_Sync_Missing_Team_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Missing_Team_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_missing_team_error(inputs)
	if (locale === "de") return de_team_sync_missing_team_error(inputs)
	if (locale === "it") return it_team_sync_missing_team_error(inputs)
	if (locale === "ru") return ru_team_sync_missing_team_error(inputs)
	if (locale === "es") return es_team_sync_missing_team_error(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_missing_team_error(inputs)
	if (locale === "ja") return ja_team_sync_missing_team_error(inputs)
	if (locale === "hi") return hi_team_sync_missing_team_error(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_missing_team_error(inputs)
	return en_team_sync_missing_team_error(inputs)
});